module.exports = "\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/product-components/delete-product/delete-product.component.css
// module id = ./src/app/product-components/delete-product/delete-product.component.css
// module chunks = main